import { IFromPrice, ISFCCGroupPrice } from '@gn-audio/core/api/pricing/models';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';

export const sortGroupsByPrice = (groups: IProductWithAttributes[], prices: (IFromPrice | ISFCCGroupPrice)[] | null): IProductWithAttributes[] => {
  if (!prices) {
    return groups;
  }

  const sortedGroups = groups
    .sort((a: IProductWithAttributes, b: IProductWithAttributes) => {
      const aPrice: IFromPrice | ISFCCGroupPrice | undefined = prices.filter((p) => p.groupId === a.groupId)[0];
      const bPrice: IFromPrice | ISFCCGroupPrice | undefined = prices.filter((p) => p.groupId === b.groupId)[0];

      if (!aPrice || !bPrice) {
        return 0;
      }

      // 0 - Add to cart (must be first)
      // 1 - Preorder
      // 2 - Backorder
      // 3 - Where to buy
      // 4 - Coming soon
      return aPrice.availabilityState - bPrice.availabilityState;
    });

  return sortedGroups;
};
